import type { IndicatorKey } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/IndicatorKey.ts";

export const PERIOD_SUMMARY_INDICATORS_KEYS: IndicatorKey[] = [
  "netSales",
  "grossSales",
  "avgTicket",
  "totalTickets",
  "avgCoverTtc",
  "totalCovers",
  "headcount",
  "laborCost",
  "workedTimeMinutes",
  "laborRatio",
  "productivityPerHour",
  "productivityPerPerson",
];
